import { useContext } from "react";
import { LoginContext } from "../../../App";
import { useNavigate } from "react-router-dom";

const useLogout = () => {
    const { loginData, setLoginData } = useContext(LoginContext);
    const navigate = useNavigate();
    
    const handleLogout = () => {
        localStorage.removeItem('loginData'); // Clear login data from local storage
        setLoginData(null);
        navigate('/login?organizationUuid=' + loginData.loggedOrganizationUuid);
    };

    return handleLogout;
}

export default useLogout;